import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthenticationContainer } from 'entities/Authentication';
import { LANGUAGES } from 'entities/Language';
import { useUserAuthData } from 'entities/User';
import { CreateInvite } from 'features/CreateInvite';
import { getRouteIndiaLanding, getRouteLogin, getRouteMain } from 'shared/consts/routes';
import { setIngressPath } from 'shared/lib/ingressPath';
import { Typography } from 'shared/_ui';

import styles from './styles.module.scss';

export const IndiaLandingPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const authData = useUserAuthData();
  const navigate = useNavigate();

  React.useEffect(() => {
    i18n.changeLanguage(LANGUAGES[0]);
    setIngressPath(getRouteIndiaLanding());
  }, [i18n]);

  React.useEffect(() => {
    if (authData) navigate(getRouteMain());
  }, [authData, navigate]);

  const benefits = t('landing.india.benefits', { returnObjects: true }) as string[];

  return (
    <AuthenticationContainer
      title={
        <div className={styles.title}>
          <Typography.Title level={2}>
            {t('landing.india.title')}
          </Typography.Title>
          <Typography.Text className={styles.titleSubtitle}>
            {t('landing.india.titleSubtitle')}
          </Typography.Text>
        </div>
      }
      hint={
        <div className={styles.hint}>
          <Typography.Text type="secondary">
            {t('authentication.registration.alreadyHaveAccount')}
          </Typography.Text>
          <Typography.Link type="primary">
            <Link to={getRouteLogin()}>{t('authentication.registration.login')}</Link>
          </Typography.Link>
        </div>
      }
    >
      <div className={styles.content}>
        <div className={styles.hero}>
          <Typography.Text type="success" strong className={styles.badge}>
            {t('landing.india.badge')}
          </Typography.Text>
          <Typography.Text type="secondary" className={styles.subtitle}>
            {t('landing.india.subtitle')}
          </Typography.Text>
          <ul className={styles.benefits}>
            {benefits.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
        </div>
        <CreateInvite />
      </div>
    </AuthenticationContainer>
  );
};
